// @noflow
import { ACCOUNT_ROUTES } from '@/routes'
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/elements/atoms/Button'
import Notification from '@/components/elements/atoms/InPageNotification/InPageNotification'

const MissingPaymentAlert = (): JSX.Element => {
  const navigate = useNavigate()
  const onClickAddPaymentMethod = useCallback(() => {
    navigate(ACCOUNT_ROUTES.paymentMethods)
  }, [navigate])

  return (
    <Notification
      text={{
        text: 'missing_payment_method_card.title',
        namespace: 'shared'
      }}
      variant="error"
    >
      <Button
        onClick={onClickAddPaymentMethod}
        typography={{
          namespace: 'shared',
          text: `missing_payment_method_card.link`,
          bold: true,
          colour: 'dangerRed400',
          variant: 'textRegular16',
          shouldScale: true
        }}
        variant="noStyling"
        identifier="missing_payment_method_card.update_payment_method"
      />
    </Notification>
  )
}

export { MissingPaymentAlert }
